import React, { ReactElement } from 'react';
import './TextField.css';
import { ReactComponent as ErrorIcon } from './errorIcon.svg';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  placeholder: string;
  value: string;
  type?: 'password' | 'email' | 'text';
  actionComponent?: ReactElement;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string | null;
}

const TextField: React.FC<Props> = ({
  label,
  actionComponent,
  onInvalid,
  children,
  errorMessage,
  ...props
}) => (
  <div className="field-container">
    <span className="label-section">
      <label htmlFor={props.id} className="label">
        {label}
      </label>
      {actionComponent}
    </span>
    <div className="text-input-container">
      <input
        onInvalid={(e) => {
          e.preventDefault();
          onInvalid && onInvalid(e);
        }}
        autoFocus
        {...props}
        className={`${props.className ?? ''} ${errorMessage ? 'text-input--error' : ''} text-input`}
      />
      {children}
    </div>
    {errorMessage !== undefined &&
      (errorMessage !== null ? (
        <div className="text-input__error-message">
          <ErrorIcon />
          <span aria-live="assertive">{errorMessage}</span>
        </div>
      ) : (
        <div className="text-input__error-message-placeholder" />
      ))}
  </div>
);
export default TextField;
